import React, { useState, useEffect } from "react";
import $ from "jquery";
import Loader from "../components/Loader";
import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { getTranslatedPath } from "../utils/languageUtils";
import { Link } from "react-router-dom";
import Seo from "../components/Seo";
import Modal from "react-bootstrap/Modal";
import jsonp from "jsonp";
import Cookies from "js-cookie";
import OwlCarousel from "react-owl-carousel";
import HeroBanner from '../components/HeroBanner';
import CookieConsent from "react-cookie-consent";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import HomeFeaturedCard from "../components/HomeFeaturedCard";
import HomeCustomCard from "../components/HomeCustomCard";
import HomeCarouselCard from "../components/HomeCarouselCard";
import HomePopularCard from "../components/HomePopularCard";
import products from "../data/products.json";
import heroData from '../data/hero.json';
import LatestNewsCard from "../components/LatestNewsCard";
import { fixMojibake } from "../utils/fix-mojibake";
import { fetchNewsList } from "../lib/newsApi";
import {
  fetchPrioritizedLatestProducts,
  fetchProductsByOrderedTagValues,
  fetchProductsByTagValue,
} from "../lib/medusa";

export default function Home2({ setHeader }) {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const { data: newsItems = [], isLoading: isNewsLoading, isError: isNewsError } = useQuery({
    queryKey: ["news"],
    queryFn: fetchNewsList,
  });
  const newsArray = newsItems;
  const numberOfNewsToDisplay = 6;
  const [viewScrollUp, setViewScrollUp] = useState(false);
  const [screenSize, setScreenSize] = useState(getCurrentDimension());
  const [loading, setLoading] = useState(false);
  const [sub, setSub] = useState(false);
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [show, setShow] = useState(false);

  const banners = Object.values(heroData);

  const handleClose = () => {
    setShow(false);
    Cookies.set("modalClosed", true, { expires: 10 });
  };

  useEffect(() => {
    const cookieExists = Cookies.get("modalClosed");
    const newsletterSubscribed = Cookies.get("newsletterSubscribed");

    if (cookieExists || newsletterSubscribed) {
      setShow(false);
    } else {
      const modalTimeout = setTimeout(() => {
        setShow(true);
      }, 4000);

      return () => clearTimeout(modalTimeout);
    }
  }, []);

  function isValidEmail(email) {
    // Use a regular expression or any other validation logic to validate email format
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    return emailRegex.test(email);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    // Validate email
    if (!email.trim()) {
      setLoading(false);
      setEmailError(t("errors.email"));
    } else if (!isValidEmail(email)) {
      setLoading(false);
      setEmailError(t("errors.emailInvalid"));
    } else {
      const url =
        "https://gmail.us13.list-manage.com/subscribe/post-json?u=f5e02948469133d4eb19aa26c&id=8d67ad26d9&f_id=0080e6e2f0";
      jsonp(`${url}&EMAIL=${email}`, { param: "c" }, (_, { msg }) => {
        setLoading(false);
        setSub(true);
        Cookies.set("newsletterSubscribed", true, { expires: 60 });
        const timeoutId = setTimeout(() => {
          setShow(false);
        }, 3000);
        return () => clearTimeout(timeoutId);
      });
    }
  };

  useEffect(() => {
    setEmailError(""); // Clear the error message when the language changes
  }, [i18n.language]);

  useEffect(() => {
    if (sub) {
      const timeoutId = setTimeout(() => {
        setSub(false);
      }, 3000);

      return () => clearTimeout(timeoutId);
    }
  }, [sub]);

  const handleChange = (e) => {
    setEmail(e.target.value);
    setEmailError(""); // Clear the error message when the email is modified
  };

  const [isMobile, setIsMobile] = useState(false);

  function getCurrentDimension() {
    return {
      width: window.innerWidth,
      height: window.innerHeight,
    };
  }

  useEffect(() => {
    const updateDimension = () => {
      setScreenSize(getCurrentDimension());
    };
    window.addEventListener("resize", updateDimension);

    return () => {
      window.removeEventListener("resize", updateDimension);
    };
  }, [screenSize]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 150) {
        setViewScrollUp(true);
      } else {
        setViewScrollUp(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    // Function to check screen size
    const checkScreenSize = () => {
      if (window.innerWidth <= 767) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    };

    // Check on initial render
    checkScreenSize();

    // Add event listener to handle screen resize
    window.addEventListener("resize", checkScreenSize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 1) {
        setHeader(true);
      } else {
        setHeader(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [setHeader]);

  const translatedPaths = getTranslatedPath(i18n.language);
  const alternateLinks = [
    { hrefLang: "en", href: "/en" },
    { hrefLang: "sr", href: "/sr" },
  ];

  const HOME_POPULAR_TAG = "home-popular";
  const FEATURED_TAGS = [
    "home-featured-01",
    "home-featured-02",
    "home-featured-03",
    "home-featured-04",
  ];
  const IN_FOCUS_TAGS = [
    "home-in-focus-01",
    "home-in-focus-02",
    "home-in-focus-03",
    "home-in-focus-04",
  ];
  const NEW_PRIORITY_TAG = "new-priority";

  const { data: homePopularProductsData } = useQuery({
    queryKey: ["home-popular-products", HOME_POPULAR_TAG],
    queryFn: () => fetchProductsByTagValue(HOME_POPULAR_TAG, 1, 0),
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
  const homePopularProducts = homePopularProductsData?.[0] || [];
  const homePopularDisplayProducts =
    homePopularProducts.length > 0 ? homePopularProducts.slice(0, 1) : products.focus;

  const { data: featuredProductsData } = useQuery({
    queryKey: ["home-featured-products", ...FEATURED_TAGS],
    queryFn: () => fetchProductsByOrderedTagValues(FEATURED_TAGS),
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
  const featuredProducts = featuredProductsData || [];
  const featuredDisplayProducts =
    featuredProducts.length > 0 ? featuredProducts.slice(0, 8) : products.featured;

  const { data: inFocusProductsData } = useQuery({
    queryKey: ["home-in-focus-products", ...IN_FOCUS_TAGS],
    queryFn: () => fetchProductsByOrderedTagValues(IN_FOCUS_TAGS),
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
  const inFocusProducts = inFocusProductsData || [];
  const inFocusDisplayProducts =
    inFocusProducts.length > 0 ? inFocusProducts.slice(0, 4) : products.spotlight;

  const { data: newProductsData } = useQuery({
    queryKey: ["home-new-products", NEW_PRIORITY_TAG],
    queryFn: () => fetchPrioritizedLatestProducts(NEW_PRIORITY_TAG, 8),
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
  const newProducts = newProductsData?.[0]?.length
    ? newProductsData[0]
    : products.featured.slice(0, 8);

  const formatHomePrice = (product) => {
    const price = product?.variants?.[0]?.prices?.[0];
    if (!price?.amount) return product?.price || "";
    const amount = price.amount;
    const currency = (price.currency_code || "RSD").toUpperCase();
    return new Intl.NumberFormat(i18n.language === "sr" ? "sr-RS" : "en-US", {
      style: "currency",
      currency,
      minimumFractionDigits: currency === "RSD" ? 0 : 2,
      maximumFractionDigits: currency === "RSD" ? 0 : 2,
    }).format(amount);
  };

  const buildHomeDescription = (product) => {
    const variantTitle = product?.variants?.[0]?.title;
    const type = product?.type?.value || product?.subtitle;
    if (variantTitle && type) return `${variantTitle} | ${type}`;
    return variantTitle || type || product?.description || "";
  };

  const buildStoreHref = (product) => {
    if (product?.href) return product.href;
    if (!product?.handle) return "#";
    const shopLanguage = i18n.language === "sr" ? "rs" : "en";
    return `https://shop.parfimerija-duro.rs/${shopLanguage}/products/${product.handle}`;
  };

  const getHomeProductImage = (product) =>
    product?.thumbnail || product?.images?.[0]?.url || product?.image || "";

  const getHomeProductCollection = (product) =>
    product?.collection?.title || product?.collection || "";

  return (
    <>
      <Seo
        title={t("header.home.pageTitle")}
        description={t("header.home.metaDescription")}
        path={`/${i18n.language}`}
        alternateLinks={alternateLinks}
      />
      <Loader />
      {/* // Main content Start  */}
      <div className="main-content main-content-overflow bg-041e42">
        {banners.length > 1 ? (
          <OwlCarousel
            className="home-hero-carousel owl-carousel"
            loop={true}
            items={1}
            margin={0}
            autoplay={true}
            autoplayHoverPause={true}
            autoplayTimeout={6500}
            smartSpeed={800}
            dots={true}
            nav={false}
          >
            {banners.map((bannerData) => (
              <HeroBanner
                key={bannerData.className}
                bannerData={bannerData}
              />
            ))}
          </OwlCarousel>
        ) : banners[0] ? (
          <HeroBanner bannerData={banners[0]} />
        ) : null}

        <section class="container pt-30">
          <div class="row">
            <div class="col-lg-5 popular">
              <div className="sec-title">
                <h2 className="title pb-22">{t("home.popular.title")}</h2>
                <div
                  className={`heading-border-line mb-40 ${
                    isMobile ? "" : "left-style"
                  }`}
                ></div>
              </div>
              <div class="row">
                {homePopularDisplayProducts.map((product, index) => (
                  <HomePopularCard
                    key={product?.id || index}
                    title={fixMojibake(product?.title || "")}
                    badgeText={product?.badgeText || "POPULAR"}
                    image={getHomeProductImage(product)}
                    href={buildStoreHref(product)}
                    alt={product?.alt || product?.title || "Popular product"}
                    iconClass={product?.iconClass || "fa fa-shopping-cart"}
                    cardClass={product?.cardClass || "popular-card"}
                  />
                ))}
              </div>
            </div>
            <div class="col-lg-7 in-focus">
              <div className="sec-title">
                <h2 className="title pb-22">{t("home.brandInFocus.title")}</h2>
                <div
                  className={`heading-border-line mb-40 ${
                    isMobile ? "" : "left-style"
                  }`}
                ></div>
              </div>
              <div class="row">
                {products.brand.map((product, index) => (
                  <HomePopularCard
                    key={index}
                    title={fixMojibake(product.title)}
                    badgeText={product.badgeText}
                    image={product.image}
                    href={product.href}
                    alt={product.alt}
                    iconClass={product.iconClass}
                    cardClass={product.cardClass}
                  />
                ))}
              </div>
            </div>
          </div>
        </section>

        <section class="container pt-30">
          <div class="col-lg-12 popular">
            <div className="sec-title text-center">
              <span className="sub-text">
                {t("home.featuredProducts.subText")}
              </span>
              <h2 className="title pb-22">
                {t("home.featuredProducts.title")}
              </h2>
              <div class="heading-border-line mb-40"></div>
            </div>
          </div>
          <div class="col-lg-12 ">
            <div class="row">
              <ul className="product-wrapper">
                {featuredDisplayProducts.map((product, index) => (
                  <HomeFeaturedCard
                    key={product?.id || index}
                    image={getHomeProductImage(product)}
                    collection={getHomeProductCollection(product)}
                    title={fixMojibake(product?.title || "")}
                    description={buildHomeDescription(product)}
                    price={product?.price || formatHomePrice(product)}
                    href={buildStoreHref(product)}
                  />
                ))}
              </ul>
            </div>
          </div>
        </section>

        <section class="container py-3">
          <div class="col-lg-12 popular">
            <div className="sec-title text-center">
              <span className="sub-text">
                {t("home.ourRecommendations.subText")}
              </span>
              <h2 className="title pb-22">
                {t("home.ourRecommendations.title")}
              </h2>
              <div class="heading-border-line mb-40"></div>
            </div>
          </div>
          <div class="col-lg-12 ">
            <div class="row">
              <ul className="product-wrapper">
                {inFocusDisplayProducts.map((product, index) => (
                  <HomeFeaturedCard
                    key={product?.id || index}
                    image={getHomeProductImage(product)}
                    collection={getHomeProductCollection(product)}
                    title={fixMojibake(product?.title || "")}
                    description={buildHomeDescription(product)}
                    price={product?.price || formatHomePrice(product)}
                    href={buildStoreHref(product)}
                  />
                ))}
              </ul>
            </div>
          </div>
        </section>

        <section class="container py-3">
          <div class="col-lg-12 carousel">
            <div class="row">
              <OwlCarousel
                className="rs-carousel owl-carousel"
                loop={true}
                items={2}
                margin={30}
                autoplay={true}
                autoplayHoverPause={true}
                autoplayTimeout={5000}
                smartSpeed={800}
                dots={true}
                nav={false}
                navSpeed={false}
                center={false}
                navText={[
                  "<i class='flaticon-left-arrow'></i>",
                  "<i class='flaticon-right-arrow'></i>",
                ]}
                responsive={{
                  0: {
                    items: 1,
                    nav: false,
                    dots: true,
                    center: false,
                  },
                  768: {
                    items: 1,
                    nav: false,
                    dots: true,
                    center: false,
                  },
                  992: {
                    items: 1,
                    nav: false,
                    dots: true,
                    center: false,
                  },
                  1200: {
                    items: 1,
                    nav: false,
                    dots: true,
                    center: false,
                  },
                }}
              >
                {products.carousel.map((product, index) => (
                  <HomeCarouselCard
                    key={index}
                    image={product.image}
                    href={product.href}
                    alt={product.alt}
                    iconClass={product.iconClass}
                  />
                ))}
              </OwlCarousel>
            </div>
          </div>
        </section>

        <section class="container py-3">
          <div class="col-lg-12 popular">
            <div className="sec-title text-center">
              <span className="sub-text">
                {t("home.newProducts.subText")}
              </span>
              <h2 className="title pb-22">
                {t("home.newProducts.title")}
              </h2>
              <div class="heading-border-line mb-40"></div>
            </div>
          </div>
          <div class="col-lg-12 ">
            <div class="row">
              <ul className="product-wrapper">
                {newProducts.map((product, index) => (
                  <HomeFeaturedCard
                    key={product?.id || index}
                    image={getHomeProductImage(product)}
                    collection={getHomeProductCollection(product)}
                    title={fixMojibake(product?.title || "")}
                    description={buildHomeDescription(product)}
                    price={product?.price || formatHomePrice(product)}
                    badge={t("home.newProducts.badge", { defaultValue: "NEW" })}
                    href={buildStoreHref(product)}
                  />
                ))}
              </ul>
            </div>
          </div>
        </section>

        {/*<section class="container py-3">
          <div class="col-lg-12 popular">
            <div className="sec-title text-center">
              <span className="sub-text">
                {t("home.specialPromotion.subText")}
              </span>
              <h2 className="title pb-22">
              {t("home.specialPromotion.title")}
              </h2>
              <div class="heading-border-line mb-40"></div>
            </div>
          </div>
          <div class="col-lg-12 ">
            <div class="row">
              <ul className="product-wrapper">
                {products.promotion.map((product, index) => (
                  <HomeFeaturedCard
                    key={index}
                    image={product.image}
                    collection={product.collection}
                    title={fixMojibake(product.title)}
                    description={product.description}
                    price={product.price}
                    badge={product.badge}
                    href={product.href}
                  />
                ))}
              </ul>
            </div>
          </div>
        </section>*/}

        <section class="container py-5">
          <div class="col-lg-12 popular">
            <div className="sec-title text-center">
              <span className="sub-text">
              {t("home.ourRecommendations.subText")}
              </span>
              <h2 className="title pb-22">
                {t("home.ourRecommendations.title")}
              </h2>
              <div class="heading-border-line mb-40"></div>
            </div>
          </div>
          <div class="col-lg-12 ">
            <div className="row custom-cards">
              <div className="container mt-5">
                <div className="row g-4">
                  {products.customCards.map((product, index) => (
                    <HomeCustomCard
                      key={index}
                      image={product.image}
                      href={product.href}
                      alt={product.alt}
                      badge={product.badge}
                      badgeClass={product.badgeClass}
                      overlayText={product.overlayText[currentLanguage]}
                      customClass={product.customClass}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="container py-5 mt--200">
          <div
            id="rs-about"
            className="rs-about style height-ctrl md-pb-30 md-pt-30 col-lg-12"
          >
            <div className="row y-middle">
              <div className="col-lg-6 md-mb-70">
                <div className="about-img">
                  <img
                    src="/assets/images/home/team-0824-[about-2x].jpg"
                    alt="Our Story"
                  />
                </div>
              </div>
              <div className="col-lg-6 pl-50 md-pl-15">
                <div className="sec-title">
                  <h2 className="title title2 title3 pb-30">
                    {t("home.story.title")}
                  </h2>
                  <p className="desc-small pb-25">{t("home.story.desc1")} </p>
                  <p className="desc-small">{t("home.story.desc2")}</p>
                  <div className="btn-part mt-40">
                    <Link
                      className="readon btn-text ticket"
                      to={translatedPaths["our-story"]}
                    >
                      <span>{t("home.explore")}</span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="container py-5">
          <div
            id="rs-about"
            className="rs-about style height-ctrl md-pb-40 md-pt-40"
          >
            <div className="row y-middle">
              <div className="col-lg-6 pl-50 md-pl-15">
                <div className="sec-title">
                  <h2 className="title title2 title3 pb-30">
                    {t("home.boutique.title")}
                  </h2>
                  <p className="desc-small pb-25">
                    {t("home.boutique.desc1")}{" "}
                  </p>
                  <p className="desc-small">{t("home.boutique.desc2")}</p>
                  <div className="btn-part mt-40">
                    <Link
                      className="readon btn-text ticket"
                      to={translatedPaths["gallery"]}
                    >
                      <span>{t("home.read")}</span>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 md-mb-40 md-mt-40">
                <div className="about-img">
                  <img
                    src="/assets/images/home/boutique-0824-[about-2x].jpg"
                    alt="Our Perfumery"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="container py-5">
          <div
            id="rs-blog"
            className="rs-blog blog-main-home home3-blog-style height-ctrl md-pb-40 md-pt-40"
          >
            <div className="row">
              <div className="sec-title text-center mb-60 md-mb-40">
                <h2 className="title title2 title3 text-middle">
                  {t("home.news.title")}
                </h2>
              </div>
              {isNewsLoading ? (
                <div className="col-12 text-center">{t("loading")}</div>
              ) : isNewsError ? (
                <div className="col-12 text-center">{t("errors.failed")}</div>
              ) : (
                <OwlCarousel
                  className="rs-carousel owl-carousel"
                  loop={true}
                  items={3}
                  margin={30}
                  autoplay={true}
                  autoplayHoverPause={true}
                  autoplayTimeout={5000}
                  smartSpeed={800}
                  dots={true}
                  nav={false}
                  navSpeed={false}
                  center={false}
                  navText={[
                    "<i class='flaticon-left-arrow'></i>",
                    "<i class='flaticon-right-arrow'></i>",
                  ]}
                  responsive={{
                    0: {
                      items: 1,
                      nav: false,
                      dots: true,
                      center: false,
                    },
                    768: {
                      items: 2,
                      nav: false,
                      dots: true,
                      center: false,
                    },
                    992: {
                      items: 2,
                      nav: false,
                      dots: true,
                      center: false,
                    },
                    1200: {
                      items: 3,
                      nav: false,
                      dots: true,
                      center: false,
                    },
                  }}
                >
                  {newsArray.slice(0, numberOfNewsToDisplay).map((news) => (
                    <LatestNewsCard key={news.title} news={news} />
                  ))}
                </OwlCarousel>
              )}
            </div>
          </div>
        </section>

        <section className="container py-5">
          <div className="rs-services style1 bg1">
            <div className="container">
              <div className="row y-middle">
                <div className="col-lg-4 col-md-6 md-mb-30">
                  <div className="services-item">
                    <div className="services-wrap">
                      <div className="services-icon">
                        <i class="fa fa-truck-fast"></i>
                      </div>
                      <div className="services-text">
                        <h4 className="title">{t("home.shipping.title")}</h4>
                        <p className="services-txt">
                          {t("home.shipping.description")}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 md-mb-30">
                  <div className="services-item">
                    <div className="services-wrap">
                      <div className="services-icon">
                        <i class="fa fa-money-bill-transfer"></i>
                      </div>
                      <div className="services-text">
                        <h4 className="title"> {t("home.moneyBack.title")}</h4>
                        <p className="services-txt">
                          {t("home.moneyBack.description")}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="services-item">
                    <div className="services-wrap">
                      <div className="services-icon">
                        <i class="fa fa-gift"></i>
                      </div>
                      <div className="services-text">
                        <h4 className="title">
                          {t("home.surpriseGift.title")}
                        </h4>
                        <p className="services-txt">
                          {t("home.surpriseGift.description")}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* <!-- start scrollUp  --> */}
        <div
          id="scrollUp"
          className={viewScrollUp ? "orange-color show" : "orange-color"}
          onClick={() =>
            $("html,body").animate(
              {
                scrollTop: 0,
              },
              500
            )
          }
        >
          <i className="fa fa-angle-up"></i>
        </div>
        {/* <!-- End scrollUp  --> */}
        <Modal
          show={show}
          onHide={handleClose}
          centered
          backdrop="static"
          className="subscribe-modal"
        >
          <Modal.Body className="p-0">
            <div className="p-0 modal__content">
              <div className="col-5 px-0 d-none d-md-block">
                <img
                  src="/assets/images/modal/main.jpg"
                  alt="niche perfumery"
                  className="modal__img"
                />
              </div>
              <div className="col-md-7 modal__text-content py-4 px-md-5 px-4">
                <div className="modal__close-btn" onClick={handleClose}>
                  <div className="close-container">
                    <div className="leftright"></div>
                    <div className="rightleft"></div>
                    {/* <label className="close-label">close</label> */}
                  </div>
                </div>
                <h3 className="modal__heading mt-4">
                  {t("modal.subscribe.title")}
                </h3>
                <div className="modal__description">
                  {t("modal.subscribe.desc")}
                </div>
                <div className="modal_form">
                  <div className="newsletter-wrap">
                    <form
                      className="newsletter-form"
                      onSubmit={handleSubmit}
                      noValidate
                    >
                      <input
                        type="email"
                        name="email"
                        placeholder={t("yourEmail")}
                        required=""
                        value={email}
                        onChange={handleChange}
                      />
                      {emailError && (
                        <div className="error-message">* {emailError}</div>
                      )}
                      <em className="paper-plane">
                        <input type="submit" value="Subscribe" />
                      </em>
                    </form>
                    <div className="col-6"></div>
                    {loading ? (
                      <div className="col-6 d-flex justify-content-start align-items-center">
                        <div
                          className="spinner-grow spinner-grow-sm"
                          role="status"
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                        <p className="mb-0">{t("errors.submitting")}</p>
                      </div>
                    ) : sub ? (
                      <div className="d-flex justify-content-start align-items-center">
                        <i className="fa fa-check"></i>
                        <p className="mb-0">{t("errors.thanks")}</p>
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="modal__privacy">
                  {t("modal.subscribe.notice")}{" "}
                  <Link to={translatedPaths["privacy"]}>
                    <span>{t("modal.subscribe.policy")} »</span>
                  </Link>
                </div>
                <div className="modal__cancel mt-4">
                  <a href="#!" onClick={handleClose}>
                    {t("modal.subscribe.decline")}
                  </a>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
      {/* // Main content End  */}
      <CookieConsent
        // debug
        buttonText={t("modal.cookies.accept")}
        buttonClasses="accept-cookies-btn"
        containerClasses="cookie-consent-container"
        style={{
          background: "#ffffff",
          alignItems: "center",
          gap: "1em",
          zIndex: "10000",
          color: "#020f2f",
        }}
      >
        <p className="m-0">{t("modal.cookies.consent")}</p>
        <p className="m-0">
          {t("modal.cookies.notice")}{" "}
          <Link className="cookie-policy-btn" to={translatedPaths["privacy"]}>
            <span>{t("modal.cookies.policy")} »</span>
          </Link>
        </p>
      </CookieConsent>
    </>
  );
}
